<template>
  <div
    ref="container"
    class="bit-loading-lottie"
    :style="{ width: props.width, height: props.height }"
    aria-label="加载中"
  ></div>
</template>

<script setup lang="ts">
import type { AnimationItem } from 'lottie-web'
import defaultAnimationData from '~/assets/lottie/bit-loading.json'

const props = withDefaults(
  defineProps<{
    animationData?: Record<string, unknown>
    width?: string
    height?: string
  }>(),
  {
    animationData: () => defaultAnimationData,
    width: '240px',
    height: '60px',
  },
)

const containerRef = useTemplateRef<HTMLDivElement>('container')
let animation: AnimationItem | null = null

onMounted(async () => {
  const container = containerRef.value
  if (!container) return

  const { default: lottie } = await import('lottie-web')
  animation = lottie.loadAnimation({
    container,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: props.animationData,
  })
})

onBeforeUnmount(() => {
  animation?.destroy()
  animation = null
})
</script>

<style scoped lang="less">
.bit-loading-lottie {
  display: flex;
  align-items: center;
  justify-content: center;

  :deep(svg) {
    display: block;
  }
}
</style>
